import { render, staticRenderFns } from "./SectionOptions.vue?vue&type=template&id=7d74d6e0&scoped=true&"
import script from "./SectionOptions.vue?vue&type=script&lang=ts&"
export * from "./SectionOptions.vue?vue&type=script&lang=ts&"
import style0 from "./SectionOptions.vue?vue&type=style&index=0&id=7d74d6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74d6e0",
  null
  
)

export default component.exports